module.exports = __webpack_public_path__ + "static/media/gt-plus-icon.da392ccb.svg";